import { CtaButton, MaskedLines, Overline, Reveal, Section } from "./ui";

const stack = [
  ["MOM, 12 meses", "R$ 147"],
  ["Agenda Viva", "R$ 37"],
  ["Caixa Hoje", "R$ 37"],
  ["Cliente Traz Cliente", "R$ 27"],
  ["Influência x Receita", "R$ 27"],
  ["Basic Recepção", "R$ 27"],
  ["Recepção 7 Dias (bônus)", "R$ 37"],
];

export default function Pricing() {
  return (
    <Section id="oferta" tone="black" className="relative overflow-hidden">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-mom-vinho/20 blur-3xl" />
      <div className="relative grid grid-cols-1 gap-16 lg:grid-cols-2">
        <div>
          <Overline>Resumo do seu acesso</Overline>
          <MaskedLines
            inView
            as="h2"
            className="mt-5 font-serif text-3xl font-medium leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-5xl"
            lines={["Tudo isso por menos", "que um horário vazio"]}
          />
          <Reveal delay={0.15} className="mt-12">
            <ul className="border-t border-white/10">
              {stack.map(([name, value]) => (
                <li key={name} className="flex items-baseline justify-between gap-4 border-b border-dashed border-white/10 py-4">
                  <span className="font-dmsans text-sm text-white/80 sm:text-base">{name}</span>
                  <span className="font-serif text-base text-white/40">{value}</span>
                </li>
              ))}
              <li className="flex items-baseline justify-between gap-4 border-b border-white/20 py-4">
                <span className="font-dmsans text-sm font-semibold uppercase tracking-[0.14em] text-white">Valor total</span>
                <span className="font-serif text-xl font-medium text-white line-through decoration-mom-carmim/70">R$ 339</span>
              </li>
            </ul>
            <p className="mt-5 font-dmsans text-sm font-semibold text-mom-carmim">
              Você economiza R$ 242 hoje.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="relative flex h-full flex-col justify-center rounded-3xl border border-white/10 bg-hc-deep p-10 sm:p-14">
          <div className="pointer-events-none absolute -inset-8 rounded-full bg-[radial-gradient(circle,rgba(229,22,69,0.18),transparent_65%)]" />
          <div className="relative text-center lg:text-left">
            <p className="font-dmsans text-[11px] font-semibold uppercase tracking-[0.28em] text-white/50">
              Preço de hoje
            </p>
            <p data-testid="pricing-price" className="mt-4 bg-gradient-to-r from-mom-carmim to-mom-vinho bg-clip-text font-serif text-7xl font-semibold leading-none tracking-tight text-transparent sm:text-8xl">
              R$ 97
            </p>
            <p className="mt-3 font-serif text-lg italic text-white/60">por 12 meses de acesso</p>
            <ul className="mt-8 space-y-2 font-dmsans text-sm text-white/60">
              <li>Um pagamento. Sem mensalidade.</li>
              <li>12 meses de acesso ao MOM.</li>
              <li>Depois desse período, você decide se deseja renovar.</li>
            </ul>
            <div className="mt-10">
              <CtaButton testId="pricing-cta" variant="white" className="w-full sm:w-auto">
                Quero parar de decidir tudo do zero
              </CtaButton>
            </div>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
